import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface TableToolbarProps {
  children?: ReactNode;
  className?: string;
}

/** A row above the grid for the consumer's own search input and action buttons. */
export const TableToolbar = ({ children, className }: TableToolbarProps) => (
  <div data-slot="table-toolbar" className={cn("flex items-center justify-between gap-2 pb-4", className)}>
    {children}
  </div>
);
